<!-- 会员管理-积分商城 -->

<template>
  <div class="points-mall main-cnt">
    <div class="title">积分商城</div>
    <div class="content">
      <common-table ref="tableRef" tableHeight="calc(100vh - 320px)" :apiName="VipApi.getIntegrationMallList"
        :columns="tableColumns" @statusChange="changeStatus">
        <template #operate>
          <el-button type="primary" round @click="openDialog"
            v-if="authData.indexOf('m_2223333444fffdcfcqqq55ggg33') != -1">
            新增积分商品
          </el-button>
        </template>
      </common-table>
    </div>

    <!-- 新增积分商品 -->
    <w-dialog ref="dialogRef" class="rule-dialog" title="新增积分商品" width="30%" btnWidth="140px" top="20vh"
      confirmText="确认保存" @wConfirm="handleSure">
      <el-form class="add-form" ref="formRef" :model="ruleForm" :rules="rules" labelPosition="top">

        <el-form-item label="商品名称" prop="im_title">
          <el-input v-model="ruleForm.im_title" clearable placeholder="请输入商品名称"></el-input>
        </el-form-item>

        <el-form-item label="积分数量" prop="im_integration_num">
          <el-input v-model="ruleForm.im_integration_num" clearable placeholder="请输入积分数量" type="number"
            oninput="if(value<0)value=0">
          </el-input>
        </el-form-item>

        <el-form-item label="原价" prop="im_original_price">
          <el-input v-model="ruleForm.im_original_price" clearable placeholder="请输入原价" type="number"
            oninput="if(value<1)value=1">
          </el-input>
        </el-form-item>

        <el-form-item label="实付价" prop="im_current_price">
          <el-input v-model="ruleForm.im_current_price" clearable placeholder="请输入实付价" type="number"
            oninput="if(value<1)value=1">
          </el-input>
        </el-form-item>
      </el-form>
    </w-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch, computed, } from "vue";
import { VipApi, } from "@/plugins/api.js";
import { ElMessage, } from "element-plus";
import { useStore } from "vuex";

// 权限
const store = useStore();
const menuTokens = computed(() => store.state.menuToken.menuTokens);
const authData = ref([]);
watch(
  () => menuTokens.value,
  (data) => {
    if (data.length) {
      authData.value = data;
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

onMounted(() => {
  tableRef.value.tableLoad();
});
const tableRef = ref(null);  // 表格对象
/** 表格配置数据 */
const tableColumns = ref([
  {
    prop: "im_id",
    label: "商品ID",
  },
  {
    prop: "im_title",
    label: "商品名称",
  },
  {
    prop: "im_integration_num",
    label: "积分数量",
  },
  {
    prop: "im_original_price",
    label: "原价",
  },
  {
    prop: "im_current_price",
    label: "实付价",
  },
  {
    type: "switch",
    prop: "im_status",
    label: "状态",
    token: "m_123ded34d667v998sadsa2c233",
  },
]);

const dialogRef = ref(null);  // 新增积分商品弹框对象
const formRef = ref(null);  // 表单对象
// 填写表单内容
const ruleForm = ref({
  im_title: '',  // 名称
  im_integration_num: 0,  // 数量
  im_original_price: 1,  // 原价
  im_current_price: 1,  // 实付价
});
// 验证必填项
const rules = reactive({
  im_title: [
    { required: true, message: "请输入商品名称", trigger: "blur", },
  ],
  im_integration_num: [
    { required: true, message: "请输入积分数量", trigger: "blur", },
  ],
  im_original_price: [
    { required: true, message: "请输入原价", trigger: "blur", },
  ],
  im_current_price: [
    { required: true, message: "请输入实付价", trigger: "blur", },
  ],
});
/**
 * 
 * 打开新增规则弹框
 * 
 * **/
const openDialog = () => {
  ruleForm.value = {
    im_title: '',
    im_integration_num: '',
    im_original_price: '',
    im_current_price: '',
  };
  dialogRef.value.show();
};
/**
 * 
 * 新增规则确认提交
 * 
 * **/
const handleSure = () => {
  formRef.value.validate((valid) => {
    if (valid) {
      dialogRef.value.isLoading = true;
      VipApi.addIntegrationMall(ruleForm.value).then((res) => {
        dialogRef.value.isLoading = false;
        if (res.Code === 200) {
          ElMessage.success('新增成功！');
          dialogRef.value.close();
          tableRef.value.tableLoad();
        } else {
          ElMessage.error(res.Message);
        }
      });
    }
  });
};
/**
 * 
 * 修改状态
 * 
 * **/
const changeStatus = (row) => {
  let data = {
    im_id: row.im_id,
    im_status: row.im_status == 1 ? 2 : 1,
  };
  VipApi.updateMallStatus(data).then((res) => {
    if (res.Code === 200) {
      ElMessage.success(row.im_status == 1 ? "关闭成功！" : "开启成功！");
      tableRef.value.tableLoad();
    } else {
      let msg = res.Message ? res.Message : "操作失败！";
      ElMessage.error(msg);
    }
  });
}
</script>
<style lang="scss">
.points-mall {
  font-family: "Source Han Sans CN";

  .content {
    padding: 15px 20px 20px;
  }

  .rule-dialog {
    .el-dialog {
      min-width: 600px;

      .el-dialog__body {
        padding: 30px;

        .el-divider--horizontal {
          margin: 10px 0;
        }
      }
    }
  }

  .el-input-group__append {
    background-color: var(--search-uncheck-bg-color);
    border: none;
  }
}
</style>